import React from "react";
import {
  Link
} from "react-router-dom";
import { connect } from "react-redux";
import config from './../config.js';
import Header from './common/header';
import Footer from './common/footer';
import './../../style/home.css';
import './../../style/signin.css';

import {
  parseQueryString
} from './../../utils/utils.js';

import store from '../../redux/store';
import { getCompanyInfo } from '../../redux/actions/company';

import Notification from 'rc-notification';
let notification = null;
Notification.newInstance({
  style: {
    top: '45px',
    right: 0
  }
}, (n) => notification = n);

class Login extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      username: '',
      password: '',
      type: 'login',
      isnotify: false,
      notify: '',
      logo: '',
      company_id: 1,
      company_name: '',
      article_link: '',
      uistyle: {},
      allow_register: true
    };
    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);


    const url = window.location.href;
    const urlparams = parseQueryString(url);
    const third_email = urlparams.get('email');
    const third_token = urlparams.get('token');


    if (typeof token == 'undefined' && typeof email == 'undefined' && typeof localStorage.token !== 'undefined' && localStorage.token !== '') {
      props.history.push('/console');
    }

    if (typeof localStorage.user == 'undefined' || (typeof localStorage.user !== 'undefined' && typeof JSON.parse(localStorage.user).company == 'undefined')) {
      localStorage.clear();
    }

    if (typeof token != 'undefined' && typeof email != 'undefined') {
      localStorage.clear();
    }

  }

  xuanwu_user() {
    const me = this;
    let domain = document.domain;
    const url = window.location.href;
    const urlparams = parseQueryString(url);
    let email = urlparams.get('email');
    const token = urlparams.get('token');
    const uid = urlparams.get('uid');

    if (typeof token != 'undefined' && typeof email != 'undefined') {
      email = email.replace(/%40/g, "@");
      const postdata = {
        'email': email,
        'token': token
      };
      fetch(config.host + '/xuanwu/auth_login_for135', {
        method: 'post',
        body: JSON.stringify(postdata)
      })
        .then(res => res.json())
        .then(json => {
          //console.log(json);
          if (json.status === 200) {

            const data = json.data;
            //console.log(data);
            localStorage.token = data.token;
            localStorage.user = JSON.stringify(data.userinfo);

            if (typeof uid != 'undefined' && uid != '') {
              me.props.history.push('/console/subject_files/0/0/0/?to=/console&uid=' + uid);
              return;
            }

            me.props.history.push('/console');
          } else {
            console.log(email);
            console.log(urlparams);
            console.log(json.message);
          }
        })
        .catch(error => {
          console.log(error);
        });
    }
  }


  getCompany() {
    const me = this;
    let domain = document.domain;
    //var domain2 = window.location.host;
    //console.log(domain) //localhost
    //console.log(domain2) //localhost:3000
    const url = window.location.href;
    const urlparams = parseQueryString(url);

    let postdata = {
      type: 'companyinfo',
      domain: domain
    };
    let formData = new FormData();
    formData.append('type', 'companyinfo');
    formData.append('domain', domain);
    let xhr = new XMLHttpRequest();
    xhr.open('POST', config.host + '/company/index', true);
    xhr.onreadystatechange = function () { //Call a function when the state changes.
      if (xhr.readyState === XMLHttpRequest.DONE && xhr.status === 200) {
        //console.log(xhr.responseText);
        const json = JSON.parse(xhr.responseText);
        //console.log(typeof json);
        if (json.status == 200) {
          //console.log(json.company_detail);
          store.dispatch(getCompanyInfo(json.company_detail));

          me.companyinfo(json.company_detail);
        }
      }
    }
    xhr.onload = function (e) {
      //console.log('Server got:', e);
    };

    xhr.send(JSON.stringify(postdata));
  }


  companyinfo(company_detail) {
    const me = this;
    if (typeof company_detail != 'undefined') {
      let company_id = company_detail.user_id;
      let article_link = '';
      let uistyle = {};
      let allow_register = true;
      switch (company_id) {
        case '3':
          article_link = 'http://alzheimer.org.cn/user/sign/login';
          break;
        case '4':
          article_link = 'http://pdicc.cn/user/sign/login';
          break;
        default:
          break;
      }
      if (company_detail.type != '') {
        //uistyle = JSON.parse(company_detail.type);
        uistyle = company_detail.type;
        allow_register = (typeof uistyle.allow_register == 'undefined') ? true : uistyle.allow_register;
      }

      me.setState({
        company_id: company_id,
        logo: company_detail.logo,
        company_name: company_detail.name,
        article_link: article_link,
        uistyle: uistyle,
        allow_register: allow_register
      });

    }

  }


  componentDidMount() {
    //this.getCompany();
    const me = this;
    //const company = thirdparty.getCompany();
    //console.log(company)
    me.getCompany();
    me.xuanwu_user();

  }


  notify(message) {
    notification.notice({
      content: <span>{message}</span>,
      duration: 4,
      style: {
        'bottom': 0,
        'right': 0
      }
    });
  }


  handleInputChange(event) {
    const target = event.target;
    //const value = target.type === 'checkbox' ? target.checked : target.value;
    const name = target.name;
    const value = target.value;

    this.setState({
      [name]: value
    });

  }
  handleSubmit(event) {
    event.preventDefault();
    event.stopPropagation();
    const me = this;
    fetch(config.host + '/user/index/', {
      method: 'post',
      body: JSON.stringify(me.state)
    })
      .then(res => res.json())
      .then(json => {
        //console.log(json);
        if (json.status === 200) {

          const data = json.data;
          //console.log(data);
          localStorage.token = data.token;
          localStorage.user = JSON.stringify(data.userinfo);

          me.props.history.push('/console');
        } else {

          me.notify(json.message);
        }

      })


      .catch(error => {
        console.log(error);
      });
    return;
  }

  onKeyDown(event: React.KeyboardEvent<HTMLDivElement>) {
    // 'keypress' event misbehaves on mobile so we track 'Enter' key via 'keydown' event
    if (event.key === 'Enter') {
      event.preventDefault();
      event.stopPropagation();
      this.handleSubmit();
    }
  }


  render() {
    const {
      logo,
      company_name,
      article_link,
      uistyle,
      allow_register
    } = this.state;
    return (
      <div>
        <Header company_name={company_name} />
        <div className="text-center mt-5 pt-5"> {logo ? <p><img src={logo} className="logo" alt="" /></p> : <h4 className="mb-3">{company_name}</h4>}</div>
        <form className="form-signin mb-5 text-center" onSubmit={this.handleSubmit}>
          <label className="sr-only">Email address</label>
          <input name="username" type="email" className="form-control" placeholder="电子邮箱" title="Email address" required autoFocus onChange={this.handleInputChange} value={this.state.username} />
          <label className="sr-only">Password</label>
          <input name="password" type="password" className="form-control" placeholder="密码" title="Password" required onChange={this.handleInputChange} value={this.state.password} />

          <button className="btn btn-lg btn-primary btn-block" type="submit" title="Sign in">登 录</button>

          <div className="clearfix py-3">
            {allow_register && <Link to={`/sign/register`} className="float-left">新用户注册</Link>}
            <Link to={`/sign/forgot`} className="float-right">找回密码</Link>
          </div>
        </form>
        {article_link ? <p className="text-center"><a href={article_link} target="_blank">文章管理，由此登录</a></p> : null}
        <Footer />
      </div>
    );
  }
}

const mapStateToProps = function (store) {
  //console.log(store)
  return {
    companyState: store.company.companyState
  };
}
export default connect(mapStateToProps)(Login);


// WEBPACK FOOTER //
// ./src/apps/site/home.js